
import { Component, Vue } from 'vue-property-decorator'
import DevToolMoveMedia from '@/components/devtools/DevToolMoveMedia.vue'
import DevToolAfas from '@/components/devtools/DevToolAfas.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { DevToolAfas, DevToolMoveMedia }
})

export default class DevTools extends Vue {
  currentTab:string = ls.get('devToolsActiveTab') || 'general'

  openTelescope () : void {
    window.open(process.env.VUE_APP_API_URL + '/inloggen', '_blank')
  }

  setActiveTab (tab:string) : void {
    ls.set('devToolsActiveTab', tab)
    this.currentTab = tab
  }

  previousPage () : void {
    this.$router.go(-1)
  }
}
